<template>
<md-layout>
    <md-layout md-flex="70">
        <md-toolbar class="md-transparent ql-dashboard-header">
            <div class="dashboard-toggles">
                <span class="dark-mode-toggle">
                    <md-switch v-model="localShowMode" id="showMode" name="showMode" @change="toggleShowMode">Dark Mode</md-switch>
                </span>
            </div>
        </md-toolbar>
    </md-layout>
    <md-layout md-flex="30">
        <md-toolbar class="md-transparent ql-dashboard-header">
            <span style="flex: 1"></span>
            <span v-if="isActivePay" class="ql-dashboard-role">Collaborator</span>
            <span v-else class="ql-dashboard-role">Observer</span>
        </md-toolbar>
    </md-layout>
</md-layout>
</template>

<script>
const DashboardHeader = {
    name: 'dashboardHeader',
    props: [
        'showMode',
        'isActivePay'
    ],
    data: function() {
        return {
            localShowMode: this.$props.showMode
        };
    },
    methods: {
        toggleShowMode() {
            this.$emit('toggleShowMode');
        }
    }
};

export default DashboardHeader;
</script>

<style lang="scss">
.ql-dashboard-header {
    width: 100%;
}
.ql-dashboard-header-pull-right {
    display: inline-block;
    float: right;
}

.dashboard-toggles {
    flex: 1;

    .md-switch {
        &.md-checked {
            .md-switch-container {
                background-color: darken(#5ecfdf, 30%) !important;

                .md-switch-thumb {
                    background-color: #5ecfdf;
                }
            }
        }
        label {
            font-weight: 100;
        }
    }
}

.dark-mode-toggle {
    margin-right: 10px;
}

.ql-dashboard-role {
    font-weight: 100;
    font-size: 14px;
    margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// header.vue?623d8b1c